import { clone } from '@baserow/modules/core/utils/object'
import { escapeRegExp } from '@baserow/modules/core/utils/string'

const CANIS_CATEGORY_ORDER = [
  'Canis - Comercial',
  'Canis - Marketing',
  'Canis - Gestão',
  'Canis - Pessoas',
  'Canis - Atendimento',
]

export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      selectedCategoryId: -1,
    }
  },
  computed: {
    /**
     * Returns the categories and templates that match the search query.
     */
    matchingCategories() {
      if (this.search === '') {
        return this.orderCategories(this.categories)
      }

      const categories = clone(this.categories)
        .map((category) => {
          category.templates = category.templates.filter((template) => {
            const keywords = template.keywords.split(',')
            keywords.push(template.name)
            const regex = new RegExp('(' + escapeRegExp(this.search) + ')', 'i')
            return keywords.some((value) => value.match(regex))
          })
          return category
        })
        .filter((category) => category.templates.length > 0)

      return this.orderCategories(categories)
    },
  },
  methods: {
    isCanisCategory(category) {
      return CANIS_CATEGORY_ORDER.includes(category.name)
    },
    orderCategories(categories) {
      return [...categories].sort((first, second) => {
        const firstOrder = CANIS_CATEGORY_ORDER.indexOf(first.name)
        const secondOrder = CANIS_CATEGORY_ORDER.indexOf(second.name)
        const firstPriority =
          firstOrder === -1 ? CANIS_CATEGORY_ORDER.length : firstOrder
        const secondPriority =
          secondOrder === -1 ? CANIS_CATEGORY_ORDER.length : secondOrder

        return (
          firstPriority - secondPriority ||
          first.name.localeCompare(second.name, 'pt-BR')
        )
      })
    },
    selectCategory(id) {
      this.selectedCategoryId = this.selectedCategoryId === id ? -1 : id
    },
  },
}
